import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "../ui/button";

const HERO = "https://images.unsplash.com/photo-1619719826894-89d6c4fd5739?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxmYXJtbGFuZCUyMGFlcmlhbCUyMHZpZXd8ZW58MHx8fHwxNzg2NjE3MjczfDA&ixlib=rb-4.1.0&q=85";

export function HeroSection({ projects }) {
  const totalPlots = projects.reduce((s, p) => s + (p.plot_count || 0), 0);
  return (
    <section className="max-w-6xl mx-auto px-6 pt-14 md:pt-20 pb-12 md:pb-16">
      <div className="grid md:grid-cols-12 gap-10 items-end">
        <div className="md:col-span-7">
          <div className="text-xs tracking-[0.25em] uppercase text-muted-foreground font-semibold mb-6">Roots · by Sanjeevani Farms</div>
          <h1 className="heading text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[0.95]">
            Own an orchard.<br />
            <span className="text-primary">Skip the sweat.</span>
          </h1>
          <p className="mt-6 text-base md:text-lg text-muted-foreground max-w-xl leading-relaxed">
            Roots by Sanjeevani Farms keeps your plots, activity logs, deeds, maintenance and cottage bookings in one calm, structured place — for owners, field crews and property managers.
          </p>
          <div className="mt-8 flex gap-3">
            <a href="#projects"><Button size="lg" data-testid="hero-cta-projects">Choose a project</Button></a>
            <Link to="/register"><Button size="lg" variant="outline" data-testid="hero-cta-signup">Create account</Button></Link>
          </div>
        </div>
        <div className="md:col-span-5">
          <div className="relative rounded-lg overflow-hidden border border-border">
            <img src={HERO} alt="Aerial farmland" className="w-full max-h-[380px] object-cover" />
            <div className="absolute bottom-3 left-3 bg-background/90 backdrop-blur px-3 py-2 rounded-md text-xs">
              <div className="uppercase tracking-widest text-[10px] text-muted-foreground">Live projects</div>
              <div className="font-semibold">{projects.length} project{projects.length === 1 ? "" : "s"} · {totalPlots} plots</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
